export default "__VITE_ASSET__e418e530__"